import getResetPasswordUrl from "core/api/getResetPasswordUrlApi/getResetPasswordUrlApi";

export const setResetPasswordUrlRedirect = async ({ documentId = '' }) => {
    const urlData = {
        cpfCnpj: documentId,
        clientid: 'CREDENTIALS',
        utm_source: 'area_cliente',
        utm_medium: 'area_logada',
        urlRedirect: window.location.href
    }

    const resetPasswordUrl = await getResetPasswordUrl(urlData);
    window.location.href = resetPasswordUrl;
    return;
};